module.exports = "/images/Batting Cages.svg?a9c704a421236544c0bb7295a8088a8f";